//
// Add View from seat functionality
//

import seatMapObject from './seat-map';

// Define S3 location
const assetUrl = 'https://sfo-tnew.s3-us-west-1.amazonaws.com/qa/img/vfs';

// Options for the observer (which mutations to observe)
const config = { attributes: false, childList: true, subtree: false }

// Callback function to execute when mutations are observed
const callback = function (mutationsList, observer) {
  // Use traditional 'for loops' for IE 11
  for (const mutation of mutationsList) {
    //check that its the modal thats been loaded and not unloaded or another div
    let isModal = (mutation.addedNodes.length > 0 && mutation.addedNodes[0].nodeType === 1 && mutation.addedNodes[0].classList.contains('tn-syos-price-types-selector-modal')) ? true : false;

    if (mutation.type === 'childList' && isModal ) {
      addImgtoNode()
      updateVFSText()
    }
  }
}

function addImgtoNode () {
  // Get details from pop-up once seat is clicked
  const seatZone = document.querySelector('.tn-syos-price-types-selector-modal .tn-syos-seat-info__header .tn-syos-seat-info__table .tn-syos-seat-info__seat-description').innerText;
  const seatRow = document.querySelector('.tn-syos-price-types-selector-modal .tn-syos-seat-info__header .tn-syos-seat-info__table .tn-syos-seat-info__seat-row').innerText.replaceAll(" ", "");
  let seatNumber = document.querySelector('.tn-syos-price-types-selector-modal .tn-syos-seat-info__header .tn-syos-seat-info__table .tn-syos-seat-info__seat-number').innerText;

  // Add leading zero if single digit
  seatNumber = String(seatNumber).padStart(2, '0');

  //
  // Add View from seat functionality
  //
  const imgThumbUrl = `${assetUrl}/expanded/`

  // Append an image to the seatmap
  const vfsImage = document.createElement('div');
  vfsImage.classList.add('vfs__image-container');
  const vfsImageTarget = document.querySelector('.modal-body .tn-syos-seat-info__header');
  vfsImageTarget.appendChild(vfsImage);

  // Create reference string
  const seatToFind = `${seatRow}_${seatNumber}`;

  let imageName = seatMap(seatToFind);

  // Show image if the screen is tablet or above
  vfsImage.innerHTML = `
    <div class="vfs__link">
        <img
        src="${imgThumbUrl}${imageName}"
        alt="View of stage from seat number ${seatRow} ${seatNumber} in ${seatZone} section"
        height="385"
        width="578"
        class="vfs__seat-img"
        >
    </div>`
}

function seatMap (seatToFind) {
  // Query the seatmap Object and return a target seat
  for (var i = 0; i < seatMapObject.length; i++){
    // look for the entry with a matching `Location` value
    if (seatMapObject[i].Location == seatToFind){
      // we found it
      return seatMapObject[i].Image
    }
  }
}

function addObserverIfDesiredNodeAvailable () {
// Check if the price container exists within the santa fe SYOS seatmap
  const targetNode = document.querySelector('.tn-syos--viewing-seats')
  if (!targetNode) {
    // The node we need does not exist yet.
    // Wait 500ms and try again
    window.setTimeout(addObserverIfDesiredNodeAvailable, 500);
    return
  }
  // Create an observer instance linked to the callback function
  const observer = new MutationObserver(callback)
  // Start observing the target node for configured mutations
  observer.observe(targetNode, config)
}
addObserverIfDesiredNodeAvailable()


function updateVFSText () {
    const title = document.querySelector('.modal-header .modal-title');  
    if (title && title.textContent.trim() === "Choose a Ticket Type") {
      title.textContent = "View from Seat";
    }

    const ticketTypes = document.querySelector('.modal-body .tn-syos-seat-info__price-type-heading'); 
    if (ticketTypes) {
      ticketTypes.textContent = "Select a Ticket Type Below:";
    }

}